import React, { Component } from "react";
import { Carousel, Button } from "react-bootstrap";
import ReactPlayer from "react-player";
import imgOnboard1 from "../../assets/images/onboard-content1.png";
import imgOnboard2 from "../../assets/images/onboard-content2.png";
import imgOnboard3 from "../../assets/images/onboard-content3.png";
import imgCamelLogo from "../../assets/images/content-camel-logo.png";

import "./Carousel.scss";

class OnboardCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
      direction: null
    };
  }

  onClickGoHead = () => {
    const { isAdmin, history } = this.props;

    this.props.changeUserAttribute({ name: 'state', value: isAdmin ? 'onboarding-01' : 'onboarding-02' });
    history.push(isAdmin ? `/onboarding/survey` : `/onboarding/infographics`);
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({ currentIndex: selectedIndex, direction: e.direction });
  };

  render () {
    return (
      <div className="onboard-carousel-wrapper">
        <Carousel
          interval={null}
          wrap={false}
          nextIcon={<span aria-hidden="true" className="carousel-control-next-icon" />}
          prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon"  />}
          activeIndex={this.state.currentIndex}
          onSelect={this.handleSelect}
        >
          <Carousel.Item>
            <img
              className="d-block onboard1"
              src={imgOnboard1}
              alt="First slide"
            />
            <img
              className="camel-logo"
              src={imgCamelLogo}
              alt="Camel Logo"
            />
            <Carousel.Caption>
              <h3>Sales <b>doesn't use</b> all that Marketing is producing.</h3>
              <h3>Marketing struggles to <b>prove the value</b> of content.</h3>
              <h3>Teams <b>duplicate work</b> because spreadsheets are out of date.</h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block onboard2"
              src={imgOnboard2}
              alt="Third slide"
            />
            <img
              className="camel-logo onboard2-logo"
              src={imgCamelLogo}
              alt="Camel Logo"
            />
            <Carousel.Caption className="onboard2">
              <h3><b>Content Camel</b> enables you to <b>organize</b> sales-focused content,</h3>
              <h3><b>understand content performance</b>, and <b>close the gap</b> on usage -- </h3>
              <h3><i>without duplicating work or updating spreadsheets.</i></h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block onboard3"
              src={imgOnboard3}
              alt="Third slide"
            />
            <img
              className="camel-logo onboard3-logo"
              src={imgCamelLogo}
              alt="Camel Logo"
            />

            <Carousel.Caption className="onboard3">
              <h3>Easily <b>distribute the latest content</b> to Sales,</h3>
              <h3><b>team access is everywhere</b> with our Chrome Extension,</h3>
              <h3>and content reports <b>show you who's engaged and what's performing.</b></h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item className="video-board">
            {this.state.currentIndex === 3 && 
              <ReactPlayer className="video-player" 
                url={this.props.isAdmin ? 'https://www.youtube.com/watch?v=mo2PCC0VusM?rel=0&cc_load_policy=1' : 'https://www.youtube.com/watch?v=P6UqJLNjgtw?rel=0&cc_load_policy=1'} 
                playing
                width="768px"
                height="432px"
                controls
                loop
              />
            }
            <Carousel.Caption className="onboard4">
              {/* <h3>See how get started quickly</h3>
              <h3><b>and upload your first content piece...</b></h3> */}
              <Button
                className="btn-danger"
                sm="true"
                onClick={this.onClickGoHead}
              >
                <b>GET STARTED</b>
              </Button>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
}

export default OnboardCarousel;
